module.exports = __webpack_public_path__ + "img/image-4.7c13e780.jpg";